<div class="dashboard">

  <h3 class="dashboard-title">Administration</h3>

  <ul class="nav dashboard-tabs" role="tablist">
    <li role="presentation" class="nav-item">
      <button class="btn btn-link nav-link" role="tab" type="button"
              [class.active]="activeTab === 'channels'"
              [attr.aria-selected]="activeTab === 'channels'"
              (click)="selectTab('channels')">Sender</button>
    </li>
    <li role="presentation" class="nav-item">
      <button class="btn btn-link nav-link" role="tab" type="button"
              [class.active]="activeTab === 'environment'"
              [attr.aria-selected]="activeTab === 'environment'"
              (click)="selectTab('environment')">Umgebung</button>
    </li>
  </ul>

  <app-channel-engine-panel [active]="activeTab === 'channels'"
                            [hidden]="activeTab !== 'channels'" role="tabpanel" />

  <app-environment-control-panel [active]="activeTab === 'environment'"
                                 [hidden]="activeTab !== 'environment'" role="tabpanel" />
</div>
